import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Settings from "../../components/management/Settings";
import Header from "../../components/management/Header";
import Sidebar from "../../components/management/Sidebar";
import Footer from "../../components/management/Footer";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";

const ManagementLayout = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()

	const [color, setColor] = useState('universal')

	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}
	const { height, width } = useWindowDimensions();
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar, theme } = result
	useEffect(() => {
		dispatch(settings.set({
			theme: 'universal',
		}))
	}, [])
	console.log(theme, 'theme')
	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			dispatch(settings.set({ primary: '#f5e93cac' }))
			dispatch(settings.set({ secondary: '#ffffff' }))

		}
		else if (theme == 'lightmode') {
			dispatch(settings.set({ primary: '#ffffffa2' }))
			dispatch(settings.set({ secondary: '#000000a2' }))
		}
		else if (theme == 'universal') {
			dispatch(settings.set({ primary: '#233C64' }))
			dispatch(settings.set({ secondary: '#ffffff' }))
		}
		else if (theme == 'luxury') {
			dispatch(settings.set({ primary: '#bd238c' }))
			dispatch(settings.set({ secondary: '#ffffff' }))

		}
		else if (theme == 'harmony') {
			dispatch(settings.set({ primary: '#000000a2' }))
			dispatch(settings.set({ secondary: '#000000a2' }))
		}
		else if (theme == 'warmth') {
			dispatch(settings.set({ primary: '#000000a2' }))

		}
		// const data = document.getElementById("layer") as HTMLInputElement;
		// data.setAttribute("fill", "#603812")
		// data.setAttribute("stroke", "#603812")
	}, [theme]);
	return (
		<>
			<ThemeProvider>
				{/* <div className="group z-40 fixed top-0 right-0   p-2  flex items-end justify-end w-24 h-24">
				<div
					className="text-white shadow-xl flex items-center justify-center p-3 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 z-50 absolute  "
					onClick={() => handleSettigns()}>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 group-hover:rotate-90 transition  transition-all duration-[0.6s]">
						<path d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
						<path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
					</svg>
				</div>
			</div> */}
				{width && width < 720 ?
					<>
						<Outlet />
					</>
					:
					<div className="leading-normal tracking-normal" id="main-body">
						<div className="flex flex-col w-full sm:hide max-h-screen h-screen bg-slate-200">
							{visible ? <Settings /> : <></>}
							<Header />

							<div className="w-full flex flex-row bg-primary">

								<Sidebar />

								<div className={`${sidebar ? `ml-64` : `ml-24 z-0 `} w-full overflow-auto mt-20 bg-slate-200 dark:bg-slate-300`}>

									<Outlet />

								</div>


							</div>
							<div className="fixed bottom-0 z-[1000] w-full bg-slate-50">
								{footer ? <Footer /> : ""}
							</div>
						</div>
					</div>}
			</ThemeProvider>
		</>
	)
}
export default ManagementLayout;